import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import Icon from '@mdi/react';
import {
  mdiViewDashboardOutline,
  mdiPackageVariantClosed,
  mdiWater,
  mdiEmailOutline,
  mdiFileDocumentOutline,
  mdiAccountGroupOutline,
  mdiArrowLeft,
  mdiDatabaseArrowRightOutline,
} from '@mdi/js';
import { adminTheme } from '../styles/adminTheme';

const SidebarContainer = styled.nav`
  width: ${adminTheme.spacing.sidebar}px;
  background: ${adminTheme.colors.sidebarBg};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: 100%;
`;

const Logo = styled.div`
  padding: 16px 16px 12px;
  font-size: 15px;
  font-weight: 700;
  color: ${adminTheme.colors.sidebarText};
  letter-spacing: 0.3px;
`;

const LogoSub = styled.div`
  font-size: 10px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 2px;
`;

const NavSection = styled.div`
  flex: 1;
  padding: 8px 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  transition: background 0.15s;

  &:hover {
    background: ${adminTheme.colors.sidebarHover};
    color: #fff;
  }

  &.active {
    background: ${adminTheme.colors.sidebarActive};
    color: #fff;
  }
`;

const BottomSection = styled.div`
  padding: 12px 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const navItems = [
  { to: '/panel', icon: mdiViewDashboardOutline, label: 'Dashboard', end: true },
  { to: '/panel/components', icon: mdiPackageVariantClosed, label: 'Components', end: false },
  { to: '/panel/fluids', icon: mdiWater, label: 'Fluids', end: false },
  { to: '/panel/rfq', icon: mdiEmailOutline, label: 'RFQ Pipeline', end: false },
  { to: '/panel/templates', icon: mdiFileDocumentOutline, label: 'Templates', end: false },
  { to: '/panel/users', icon: mdiAccountGroupOutline, label: 'Users', end: false },
  { to: '/panel/workspace', icon: mdiDatabaseArrowRightOutline, label: 'Workspace', end: false },
];

export const AdminSidebar: React.FC = () => {
  return (
    <SidebarContainer>
      <Logo>
        BSPL Selector
        <LogoSub>Admin Panel</LogoSub>
      </Logo>
      <NavSection>
        {navItems.map(item => (
          <StyledNavLink key={item.to} to={item.to} end={item.end}>
            <Icon path={item.icon} size={0.72} />
            {item.label}
          </StyledNavLink>
        ))}
      </NavSection>
      <BottomSection>
        <StyledNavLink to="/" end>
          <Icon path={mdiArrowLeft} size={0.72} />
          Back to Designer
        </StyledNavLink>
      </BottomSection>
    </SidebarContainer>
  );
};
